import { c as _c } from "react/compiler-runtime";
import { MAILING_DNS_SETTINGS_API } from 'modules/profile/mailing-settings/api/mailing-settings-domain-api';
import { MailingSettingsDomainsApiInterface } from 'modules/profile/mailing-settings/types/mailing-settings-domain-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { SwrPaginationInterface } from 'shared/types/pagination-interface';
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string';
import useSWR from 'swr';
interface useMailingDnsSettings extends SwrPaginationInterface {}
export function useMailingDnsSettings(t0) {
  const $ = _c(8);
  const {
    pagination,
    limit
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== limit || $[2] !== pagination || $[3] !== user) {
    t2 = () => user && `${MAILING_DNS_SETTINGS_API}?${getPaginationQueryString({
      pagination,
      limit
    })}`;
    $[1] = limit;
    $[2] = pagination;
    $[3] = user;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: dnsMailingSettings,
    mutate
  } = useSWR(t2, fetcher);
  let t3;
  if ($[5] !== dnsMailingSettings || $[6] !== mutate) {
    t3 = {
      dnsMailingSettings,
      mutate
    };
    $[5] = dnsMailingSettings;
    $[6] = mutate;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}